quoteModule.factory('vehicleRateService',
['$q', 'vehicleRateRetrievalService', 'vehicleProductCoordService', 'rateQuoteCoordService','dealerPreferencesService',
    'rateQuoteRetrievalCoordService', 'rateQuoteScenariosService', 'rateProductCacheService', 'TLCError','AppErrorCodes',
    'usageEventsService',
function($q, vehicleRateRetrievalService, vehicleProductCoordService, rateQuoteCoordService,dealerPreferencesService,
         rateQuoteRetrievalCoordService, rateQuoteScenariosService, rateProductCacheService, TLCError, AppErrorCodes,
         usageEventsService) {
    var vehicleRateService = {};

    var _noUpgradeSearch = "NOUPGRADE";

    var rateProductInfoPrototype = {
        productid : null,
        rates: null,
        monthsTerms: [],
        milesTerms: [],
        termAssociatedRates: [],
        chosenCoverageCode: null,
        chosenDeductibleCode: null,
        chosenProductCode: null,
        chosenBaseNoUpgradeTerm: null,
        chosenUpgradeProductCode: null,
        chosenUpgradeCoverageCode: null,
        chosenUpgradeDeductibleCode: null,
        chosenTermInternalId: null,
        chosenProductTypeCode: null,
        ratesInvalid : false
    };

    vehicleRateService.rateProductInfos = [];

    var finishedRateProcessingHandlers = [];
    var finishRateProcessing = function(productId, wasCached, err) {
        finishedRateProcessingHandlers.forEach(function(handlerObj) {
            if(handlerObj.id === productId)
                handlerObj.handler(wasCached,err);
        });
    };
    vehicleRateService.onFinishRateProcessing = function(productId, handler) {
        finishedRateProcessingHandlers.push({id:productId,handler:handler});
    };
    vehicleRateService.deregisterAllHandlers = function(){
        finishedRateProcessingHandlers = [];
    };

    vehicleRateService.beginRateForProductData = function(prodData, ignoreCachedRates) {
        //
        // COM-808
        // we will "ignore" cached rates when we are menu integrated and coming back in
        // to a saved quote, AND the product is a deal-dependent product (GAP)
        // This will force re-rating
        var productId = prodData.productInternalId;
        var productTypeId = prodData.productTypeInternalId;

        //get the saved quote for this product
        var quoteRate = rateQuoteCoordService.getRateForScenarioCodeProductId(
            rateQuoteScenariosService.getCurrentScenario(), productId);
        //are we retrieving an existing quote??
        if (!ignoreCachedRates && rateQuoteRetrievalCoordService.inQuoteRetrieval() && quoteRate != null) {
            // set term as well as get cached rates response
            rateProductCacheService.getCachedRatesForCacheId(quoteRate.cachedRateResponseId)
                .then(
                    function foundACachedRate(cacheResponse){
                        consumeCachedRate(cacheResponse, productId, productTypeId);
                        chooseRateTerm(productId, quoteRate.RatedTerms[0].RatedTerm.InternalTermId);
                        finishRateProcessing(productId);
                        quoteRate = null;
                    },
                    function didNotFindCachedRateHaveToReRate(err){
                        quoteRate = null;
                        rateAProduct(prodData)
                            .then(function() {
                                    finishRateProcessing(productId);
                                },
                                function(err){
                                    throw new TLCError(err,AppErrorCodes.CreateQuoteController_RateError);
                                }
                            );
                    }
                )
        } else {
            rateAProduct(prodData)
            .then(
                function() {
                    finishRateProcessing(productId);
                },
                function(err){
                    finishRateProcessing(productId,null,err);
                    //throw new TLCError(err,AppErrorCodes.CreateQuoteController_RateError);
                }
            );
        }
    };

    var chooseRateTerm = function(id, termId) {
        vehicleRateService.rateProductInfos[id].chosenTermInternalId = termId;
    };

    //rate the product
    var rateAProduct = function(prodInfo){
        var deferred = $q.defer();

        var id = prodInfo.productInternalId;
        var prodtypeid = prodInfo.productTypeInternalId;
        if(!vehicleRateService.rateProductInfos[id])
            vehicleRateService.rateProductInfos[id] = angular.copy(rateProductInfoPrototype);
        vehicleRateService.rateProductInfos[id].rates = null;
        vehicleRateService.rateProductInfos[id].milesTerms = [];
        vehicleRateService.rateProductInfos[id].monthsTerms = [];
        vehicleRateService.rateProductInfos[id].termAssociatedRates = [];
        //coverage, deductible, and any upgrade settings
        vehicleRateService.rateProductInfos[id].chosenProductCode = id;
        vehicleRateService.rateProductInfos[id].productid = id;
        vehicleRateService.rateProductInfos[id].chosenCoverageCode = prodInfo.selectedCoverageVal;
        vehicleRateService.rateProductInfos[id].chosenDeductibleCode = prodInfo.selectedDeductibleVal;
        vehicleRateService.rateProductInfos[id].chosenBaseNoUpgradeTerm = prodInfo.selectedUpgradeCoverageVal!=null && prodInfo.selectedUpgradeCoverageVal.toUpperCase().indexOf(_noUpgradeSearch) < 0 ? prodInfo.selectedNoUpgradeTermVal : null;
        vehicleRateService.rateProductInfos[id].chosenUpgradeProductCode = prodInfo.selectedUpgradeCoverageVal!=null && prodInfo.selectedUpgradeCoverageVal.toUpperCase().indexOf(_noUpgradeSearch) < 0 ? prodInfo.selectedUpgradeProductVal : null;
        vehicleRateService.rateProductInfos[id].chosenUpgradeCoverageCode = prodInfo.selectedUpgradeCoverageVal!=null && prodInfo.selectedUpgradeCoverageVal.toUpperCase().indexOf(_noUpgradeSearch) < 0 ? prodInfo.selectedUpgradeCoverageVal : null;
        vehicleRateService.rateProductInfos[id].chosenUpgradeDeductibleCode = prodInfo.selectedUpgradeCoverageVal!=null && prodInfo.selectedUpgradeCoverageVal.toUpperCase().indexOf(_noUpgradeSearch) < 0 ? prodInfo.selectedUpgradeDeductibleVal : null;
        //just before we rate, let's clear out the "chosen rate term" attribute
        vehicleRateService.rateProductInfos[id].chosenTermInternalId = null;

        var vehicleData = rateQuoteCoordService.VehicleData;
        var rvInfo = null;
        if (vehicleData.vehicleType!=null && vehicleData.vehicleType == 'RV'){
            rvInfo = {
                rvType : vehicleData.rvType,
                manuWarrMonths : vehicleData.rvManuMonths,
                manuWarrMiles : vehicleData.rvManuMiles,
                modelYear : vehicleData.year
            }
        }

        var prodToRateInfo = vehicleProductCoordService.buildProductToRate(
            id,
            prodInfo.selectedCoverageVal,
            prodInfo.selectedDeductibleVal,
            prodInfo.selectedOptionVal,
            prodInfo.selectedNoUpgradeTermVal,
            prodInfo.selectedUpgradeProductVal,
            prodInfo.selectedUpgradeCoverageVal,
            prodInfo.selectedUpgradeDeductibleVal,
            prodInfo.selectedUpgradeOptionVal
        );

        var partnerSpecificInfo = rateQuoteCoordService.getCapturedProviderData();

        var vehicleInfo = vehicleProductCoordService.getVehicleDetails();
        if (vehicleInfo != null) {
            vehicleRateRetrievalService.getRatesForProduct(
                vehicleInfo.dateOfSale,
                {
                    "modelId": vehicleInfo.modelId,
                    "vin": vehicleInfo.vin,
                    "makeId" : vehicleInfo.makeId,
                    "year" : vehicleInfo.year,
                    "saleType" : vehicleInfo.vehicleSaleType
                },
                vehicleInfo.odometer,
                vehicleInfo.vehicleCert,
                vehicleInfo.vehicleUsage,
                vehicleInfo.inService ? vehicleInfo.inService : null,
                rateQuoteCoordService.DealData,
                partnerSpecificInfo,
                prodToRateInfo,
                rateQuoteCoordService.getQuoteSessionId(),
                rvInfo
                )
                .then(
                    function ratesReceived(data) {
                        vehicleRateService.rateProductInfos[id].ratesInvalid = !(data.Rates[0].RatedTerms && data.Rates[0].RatedTerms.length > 0);
                        consumeRatesData(id,prodtypeid,vehicleInfo.dateOfSale, data);
                        vehicleRateService.rateProductInfos[id].chosenProductTypeCode = data.Rates[0].RatedProduct.ParentProductType.ApplicationCode;
                        prodToRateInfo = partnerSpecificInfo = null;
                        var pCat = data.Rates[0].RatedProduct.ParentProductType.ParentProductRatingCategory;
                        var prodtype = getRatedProductCatFlexField(pCat, 'COMMERCE-RATE-TYPE');
                        if (prodtype == null) { prodtype = pCat.ApplicationCode; }
                        usageEventsService.ratesRetrieved(rateQuoteCoordService.getQuoteSessionId(), prodtype);

                        deferred.resolve();
                    },
                    function(err){
                        vehicleRateService.rateProductInfos[id].ratesInvalid = true;
                        prodToRateInfo = partnerSpecificInfo = null;
                        deferred.reject(err);
                    }
                )
        }

        return deferred.promise;
    };

    var getRatedProductCatFlexField = function(productCat, fieldName) {
        var flexFields = productCat
            && productCat.PartnerSpecificFields
            && productCat.PartnerSpecificFields.FlexFields
            && productCat.PartnerSpecificFields.FlexFields;

        if (!angular.isArray(flexFields))
            return angular.undefined;

        var field = _.find(flexFields, function (fieldObj) { return fieldObj.FieldName == fieldName});

        return field && field.FieldValue;
    }

    var consumeCachedRate = function(cachedRate, id, prodtypeid) {
        if(!vehicleRateService.rateProductInfos[id])
            vehicleRateService.rateProductInfos[id] = angular.copy(rateProductInfoPrototype);

        var rate = cachedRate.Rates[0];
        var baseRate = rate.BaseNoUpgradeProductRates ? rate.BaseNoUpgradeProductRates[0] : null;
        vehicleRateService.rateProductInfos[id].chosenCoverageCode = baseRate ? baseRate.BaseRatedCoverage.InternalCoverageId : rate.RatedCoverage.InternalCoverageId;
        vehicleRateService.rateProductInfos[id].chosenDeductibleCode = baseRate ? baseRate.BaseRatedDeductible.InternalDeductibleId : rate.RatedDeductible ? rate.RatedDeductible.InternalDeductibleId : null;
        vehicleRateService.rateProductInfos[id].chosenProductCode = baseRate ? baseRate.BaseRatedProduct.InternalProductId : rate.RatedProduct.InternalProductId;
        vehicleRateService.rateProductInfos[id].chosenBaseNoUpgradeTerm = baseRate && rate.RatedCoverage.InternalCoverageId.toUpperCase().indexOf(_noUpgradeSearch) < 0 ? baseRate.BaseRatedTerm.RatedTerm.InternalTermId: null;
        vehicleRateService.rateProductInfos[id].chosenUpgradeProductCode = baseRate && rate.RatedCoverage.InternalCoverageId.toUpperCase().indexOf(_noUpgradeSearch) < 0 ? rate.RatedProduct.InternalProductId : null;
        vehicleRateService.rateProductInfos[id].chosenUpgradeCoverageCode = baseRate && rate.RatedCoverage.InternalCoverageId.toUpperCase().indexOf(_noUpgradeSearch) < 0 ? rate.RatedCoverage.InternalCoverageId : null;
        vehicleRateService.rateProductInfos[id].chosenUpgradeDeductibleCode = baseRate && rate.RatedCoverage.InternalCoverageId.toUpperCase().indexOf(_noUpgradeSearch) < 0 ? rate.RatedDeductible.InternalDeductibleId : null;

        consumeRatesData(id, prodtypeid, "", cachedRate);
    };

    var consumeRatesData = function(id, prodtypeid, dateOfSale, data){
        //it is possible we get more rates back other than the coverage/deductible/product we asked for (upgrades)
        vehicleRateService.rateProductInfos[id].rates = data;
        vehicleRateService.rateProductInfos[id].ps = data.Rates[0].RatedProduct.PartnerSpecificFields;

        vehicleRateService.rateProductInfos[id].monthsTerms = [];
        vehicleRateService.rateProductInfos[id].milesTerms = [];
        vehicleRateService.rateProductInfos[id].termAssociatedRates = [];
        for (var i=0; i <  vehicleRateService.rateProductInfos[id].rates.Rates[0].RatedTerms.length; i++)
        {
            var thisTerm = vehicleRateService.rateProductInfos[id].rates.Rates[0].RatedTerms[i];
            if (vehicleRateService.rateProductInfos[id].monthsTerms.indexOf(thisTerm.RatedTerm.TermMonths) < 0){
                vehicleRateService.rateProductInfos[id].monthsTerms.push(thisTerm.RatedTerm.TermMonths);
            }
            if (vehicleRateService.rateProductInfos[id].milesTerms.indexOf(thisTerm.RatedTerm.TermMiles) < 0){
                vehicleRateService.rateProductInfos[id].milesTerms.push(thisTerm.RatedTerm.TermMiles);
            }
            //thisTerm.RetailCostFormatted = '$' + numeral(thisTerm.RetailCost).format('0,0');

            var termKey = thisTerm.RatedTerm.TermMonths + ';' + thisTerm.RatedTerm.TermMiles;
            vehicleRateService.rateProductInfos[id].termAssociatedRates[termKey] = thisTerm;

            thisTerm = null;
        }

        var densityThreshold = 0.5;
        var totalCells = 0;
        var filledCells = 0;
        var cellDensity = 1.0;

        for (var i = 0; i < vehicleRateService.rateProductInfos[id].milesTerms.length; i = i + 1){
            for (var j = 0; j < vehicleRateService.rateProductInfos[id].monthsTerms.length; j = j + 1){
                totalCells = totalCells + 1;
                var monthTerm = vehicleRateService.rateProductInfos[id].monthsTerms[j];
                var mileTerm = vehicleRateService.rateProductInfos[id].milesTerms[i];

                if (vehicleRateService.rateProductInfos[id].termAssociatedRates[monthTerm + ';' + mileTerm]){
                    filledCells = filledCells + 1;
                }
            }
        }
        cellDensity = filledCells / totalCells;



        //forcing the UI to a "slim" if density is < 40%
        if (filledCells <= 14 && cellDensity <= densityThreshold){
            vehicleRateService.rateProductInfos[id].monthsTerms = [];
            vehicleRateService.rateProductInfos[id].milesTerms = [0];
            vehicleRateService.rateProductInfos[id].termAssociatedRates = [];
            var milesTermsOrder = [];
            var monthsTermsOrder = [];
            for (var i=0; i <  vehicleRateService.rateProductInfos[id].rates.Rates[0].RatedTerms.length; i++)
            {
                milesTermsOrder.push(vehicleRateService.rateProductInfos[id].rates.Rates[0].RatedTerms[i].RatedTerm.TermMiles);
                monthsTermsOrder.push(vehicleRateService.rateProductInfos[id].rates.Rates[0].RatedTerms[i].RatedTerm.TermMonths);
            }
            //milesTermsOrder = milesTermsOrder.sort(function (a, b) {
            //    return a - b
            //});
            //monthsTermsOrder = monthsTermsOrder.sort(function (a, b) {
            //    return a - b
            //});
            for (var i=0; i <  vehicleRateService.rateProductInfos[id].rates.Rates[0].RatedTerms.length; i++)
            {
                var thisTerm = vehicleRateService.rateProductInfos[id].rates.Rates[0].RatedTerms.filter(
                    function(rate){
                        return rate.RatedTerm.TermMonths == monthsTermsOrder[i] && rate.RatedTerm.TermMiles == milesTermsOrder[i];
                })[0];
                if (vehicleRateService.rateProductInfos[id].monthsTerms.indexOf(thisTerm.RatedTerm.TermMonths + '/' + thisTerm.RatedTerm.TermMiles) < 0){
                    vehicleRateService.rateProductInfos[id].monthsTerms.push(thisTerm.RatedTerm.TermMonths + '/' + thisTerm.RatedTerm.TermMiles);
                }
                var termKey = thisTerm.RatedTerm.TermMonths +  '/' + thisTerm.RatedTerm.TermMiles + ';0';
                vehicleRateService.rateProductInfos[id].termAssociatedRates[termKey] = thisTerm;
                vehicleRateService.rateProductInfos[id].termAssociatedRates[termKey].RatedTerm.DisplayName = thisTerm.RatedTerm.TermMonths + 'mo/' + (thisTerm.RatedTerm.TermMiles >= 1000 ? (thisTerm.RatedTerm.TermMiles / 1000) + 'k' : thisTerm.RatedTerm.TermMiles);
                thisTerm = null;
            }
        }

        var dealerPref = null;
           dealerPreferencesService.getProductDisplayPreferences(id, prodtypeid, new Date(dateOfSale))
            .then(
                function(res){
                    dealerPref = res;


                    if (!(filledCells <= 14 && cellDensity <= densityThreshold)){
                        vehicleRateService.rateProductInfos[id].milesTerms = vehicleRateService.rateProductInfos[id].milesTerms.sort(function (a, b) {
                            return a - b
                        });
                        vehicleRateService.rateProductInfos[id].monthsTerms = vehicleRateService.rateProductInfos[id].monthsTerms.sort(function (a, b) {
                            return a - b
                        });
                    }

                    if(!(dealerPref.termSortOrder == "ASCENDING" || dealerPref.termSortOrder == "ASC") )
                    {
                        vehicleRateService.rateProductInfos[id].milesTerms = vehicleRateService.rateProductInfos[id].milesTerms.reverse();
                        vehicleRateService.rateProductInfos[id].monthsTerms = vehicleRateService.rateProductInfos[id].monthsTerms.reverse();
                    }
                }
            );
    };

    return vehicleRateService;
}]);
